<template>

  <div class="container-fluid px-2 px-sm-3 px-md-4 my-3">
    <div class="row g-3">
      <!-- ENCABEZADO -->
      <div class="col-12">
        <div class="text-center py-2 border-bottom">
          <h5 class="mb-1">DEMANDAS DE EJECUCIÓN DE TÍTULO EXTRAJUDICIAL</h5>
          <div class="text-muted">{{ beneficiario }}</div>
        </div>
      </div>

      <!-- ===== COLUMNA IZQUIERDA: FORM ===== -->
      <div class="col-12 col-md-6">
        <div class="card shadow-sm border-0">
          <div class="card-body">
            <h6 class="card-title text-center mb-3">
              {{ form.id ? 'Editar' : 'Nuevo' }} Estado Legal del Crédito
            </h6>

            <form @submit.prevent="guardar">
              <div class="row g-3">
                <div class="col-12 col-sm-6">
                  <label class="form-label">Fecha</label>
                  <input type="date" class="form-control" v-model="form.fechaPresentado" />
                </div>

                <div class="col-12 col-sm-6">
                  <label class="form-label">Juzgado</label>
                  <input type="text" class="form-control" placeholder="Juzgado competente" v-model="form.juzgado" />
                </div>

                <div class="col-12 col-sm-6">
                  <label class="form-label">Estatus</label>
                  <select class="form-select" v-model="form.estatus" required>
                    <option disabled value="">Seleccione estatus</option>
                    <option v-for="opt in estatusOptions" :key="opt" :value="opt">
                      {{ opt }}
                    </option>
                  </select>
                </div>

                <div class="col-12 col-sm-6">
                  <label class="form-label">No. expediente</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Ej. EXP-123-2025"
                    v-model="form.noExpediente"
                  />
                </div>

                <!-- <div class="col-12 col-sm-6">
                  <label class="form-label">Fecha notificación</label>
                  <input type="date" class="form-control" v-model="form.fechaNotificacion" />
                </div> -->

                <!-- <div class="col-12 col-sm-6">
                  <label class="form-label">Fecha acuerdo</label>
                  <input type="date" class="form-control" v-model="form.fechaAcuerdo" />
                </div> -->

                <!-- <div class="col-12">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="continuaDemanda" v-model="form.continuaProcesoDemanda" />
                    <label class="form-check-label" for="continuaDemanda">
                      Continúa proceso de demanda
                    </label>
                  </div>
                </div> -->

                <div class="col-12">
                  <label class="form-label">Observaciones</label>
                  <textarea
                    rows="3"
                    class="form-control"
                    placeholder="Detalle del estado, acuerdos, novedades…"
                    v-model="form.observaciones">
                  </textarea>
                </div>
              </div>

              <div class="d-grid gap-2 d-sm-flex justify-content-sm-end mt-3">
                <button type="submit" class="btn btn-primary">
                  {{ form.id ? 'Actualizar' : 'Guardar' }}
                </button>
                <button v-if="form.id" type="button" class="btn btn-secondary" @click="cancelarEdicion">
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- ===== COLUMNA DERECHA: HISTORIAL ===== -->
      <div class="col-12 col-md-6">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-body d-flex flex-column">
            <h6 class="card-title text-center mb-3">Historial legal</h6>

            <div v-if="registros.length" class="table-responsive">
              <table class="table table-sm align-middle">
                <thead class="table-light">
                  <tr>
                    <th>Presentado</th>
                    <th>Juzgado</th>
                    <th>Estatus</th>
                    <th>Expediente</th>
                    <th>Notif.</th>
                    <th>Acuerdo</th>
                    <th>Demanda</th>
                    <th style="width: 110px;"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="r in registros" :key="r.id">
                    <td>{{ formatDate(r.fechaPresentado) }}</td>
                    <td>{{ r.juzgado || '—' }}</td>
                    <td>{{ r.estatus || '—' }}</td>
                    <td>{{ r.noExpediente || '—' }}</td>
                    <td>{{ formatDate(r.fechaNotificacion) }}</td>
                    <td>{{ formatDate(r.fechaAcuerdo) }}</td>
                    <td>{{ r.continuaProcesoDemanda ? 'Sí' : 'No' }}</td>
                    <td class="text-end">
                      <button class="btn btn-link btn-sm p-0 me-2" @click="editar(r)">Editar</button>
                      <button class="btn btn-link btn-sm text-danger p-0" @click="eliminar(r.id)">Eliminar</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p v-else class="text-center text-muted m-0">Aún no hay registros.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import Security from '../security';

export default {
  name: 'ProcesoLegal',
  props: {
    idCredito: { type: [Number, String], required: true },  // desde el padre
    idUsuario: { type: [Number, String], required: true },  // ← usado para user_admin
    idCliente: { type: [Number, String], default: null },
    beneficiario: { type: String, default: '' },
  },
  data() {
    return {
      registros: [],
      form: this.resetForm(),
      api: process.env.VUE_APP_API_URL,
      estatusOptions: [
        'NOTIFICADA',
        'POR NOTIFICAR',
        'PRESENTADA',
        'RECHAZADA',
        'RETORNADA',
        'SUBSANADA',
        'TRABAJO',
        'ADMITIDA',
        'TERMINDADO',
        'CONCILIACIÓN',
        'RESOLUCIÓN',
      ],
    };
  },
  computed: {
    creditoIdNum() {
      const n = Number(this.idCredito);
      return Number.isFinite(n) && n > 0 ? n : 0;
    },
    clienteIdNum() {
      const n = Number(this.idCliente);
      return Number.isFinite(n) && n > 0 ? n : 0;
    },
    userAdminNum() {
      const n = Number(this.idUsuario);
      return Number.isFinite(n) && n > 0 ? n : 0;
    },
  },
  mounted() {
    this.cargarRegistros();
  },
  watch: {
    idCredito() {
      this.form = this.resetForm();
      this.cargarRegistros();
    },
  },
  methods: {
    resetForm() {
      return {
        id: null,
        fechaPresentado: this.hoy(),
        juzgado: '',
        estatus: '',
        noExpediente: '',
        fechaNotificacion: '',
        fechaAcuerdo: '',
        continuaProcesoDemanda: false,
        observaciones: '',
      };
    },

    async parseResponse(res) {
      const text = await res.text();
      const ct = res.headers.get('content-type') || '';
      if (!res.ok) throw new Error(`HTTP ${res.status}: ${text.slice(0,200)}`);
      if (ct.includes('application/json')) {
        try { return JSON.parse(text); }
        catch { throw new Error(`JSON inválido: ${text.slice(0,200)}`); }
      }
      throw new Error(`Esperaba JSON, recibí: ${text.slice(0,200)}`);
    },

    // --- CRUD ---
    async cargarRegistros() {
      if (this.creditoIdNum <= 0) return;
      try {
        const res = await fetch(
          this.api + '/admin/estado-legal/by-credito',
          Security.requestOptions({ idCredito: this.creditoIdNum }, 'POST')
        );
        const json = await this.parseResponse(res);
        if (!json.error) this.registros = json.data.registros || [];
      } catch (err) {
        Swal.fire({ icon: 'error', title: 'Error al cargar', text: err.message });
      }
    },

    async guardar() {
      if (this.creditoIdNum <= 0) {
        Swal.fire({ icon: 'warning', title: 'Crédito inválido', text: 'No se recibió un creditoId válido.' });
        return;
      }
      if (this.userAdminNum <= 0) {
        Swal.fire({ icon: 'warning', title: 'Usuario inválido', text: 'Falta idUsuario para asignar user_admin.' });
        return;
      }

      const url = this.form.id
        ? '/admin/estado-legal/update'
        : '/admin/estado-legal/create';

      const payload = {
        creditoId: this.creditoIdNum,
        ...(this.clienteIdNum ? { clienteId: this.clienteIdNum } : {}),
        ...(this.form.id ? { id: this.form.id } : {}),
        fechaPresentado: this.isoOrNull(this.form.fechaPresentado),
        juzgado: (this.form.juzgado || '').trim(),
        estatus: (this.form.estatus || '').trim(),
        noExpediente: (this.form.noExpediente || '').trim(),
        fechaNotificacion: this.isoOrNull(this.form.fechaNotificacion),
        fechaAcuerdo: this.isoOrNull(this.form.fechaAcuerdo),
        continuaProcesoDemanda: !!this.form.continuaProcesoDemanda,
        observaciones: (this.form.observaciones || '').trim(),
        userAdmin: this.userAdminNum, // ← clave: quién crea/actualiza
      };

      try {
        const res = await fetch(this.api + url, Security.requestOptions(payload, 'POST'));
        const json = await this.parseResponse(res);
        if (json.error) throw new Error(json.message);

        Swal.fire({ icon: 'success', title: this.form.id ? 'Actualizado' : 'Creado', timer: 1200, showConfirmButton: false });
        this.form = this.resetForm();
        this.cargarRegistros();
      } catch (err) {
        Swal.fire({ icon: 'error', title: err.message });
      }
    },

    async eliminar(id) {
      const confirm = await Swal.fire({
        icon: 'warning',
        title: '¿Eliminar registro?',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      });
      if (!confirm.isConfirmed) return;

      try {
        const res = await fetch(
          this.api + '/admin/estado-legal/delete',
          Security.requestOptions({ id }, 'PUT')
        );
        const json = await this.parseResponse(res);
        if (json.error) throw new Error(json.message);

        Swal.fire({ icon: 'success', title: 'Eliminado', timer: 1000, showConfirmButton: false });
        this.cargarRegistros();
      } catch (err) {
        Swal.fire({ icon: 'error', title: err.message });
      }
    },

    editar(reg) {
      this.form = {
        id: reg.id,
        fechaPresentado: this.toInputDate(reg.fechaPresentado),
        juzgado: reg.juzgado || '',
        estatus: reg.estatus || '',
        noExpediente: reg.noExpediente || '',
        fechaNotificacion: this.toInputDate(reg.fechaNotificacion),
        fechaAcuerdo: this.toInputDate(reg.fechaAcuerdo),
        continuaProcesoDemanda: !!reg.continuaProcesoDemanda,
        observaciones: reg.observaciones || '',
      };
    },
    cancelarEdicion() {
      this.form = this.resetForm();
    },

    // --- fechas ---
    formatDate(v) {
      if (!v) return '—';
      const d = new Date(v);
      if (Number.isNaN(d.getTime())) return '—';
      const dia = ('0' + d.getUTCDate()).slice(-2);
      const mes = ('0' + (d.getUTCMonth() + 1)).slice(-2);
      const anio = d.getUTCFullYear();
      return `${dia}/${mes}/${anio}`;
    },
    toInputDate(v) {
      if (!v) return '';
      const d = new Date(v);
      return Number.isNaN(d.getTime()) ? '' : d.toISOString().slice(0, 10);
    },
    isoOrNull(v) {
      return v ? `${v}T00:00:00Z` : null;
    },
    hoy() {
      return new Date().toISOString().slice(0, 10);
    },
  },
};
</script>

<style scoped>
.container-fluid { max-width: 1400px; }
.card-title { font-weight: 600; }
</style>
